<mat-form-field #formField [floatLabel]="floatLabel" class="w-full">
  <input
    (focus)="onFocus($event)"
    (keydown.ArrowRight)="onKeyDownArrowRight($event)"
    (keydown.enter)="onKeyDownEnter($event)"
    [formControl]="control"
    [matAutocomplete]="auto"
    [placeholder]="label"
    aria-label="Number"
    matInput
    ngDefaultControl
    type="text"
  />

  @if (virtualKeyboard) {
    <button
      (click)="onKeyboardOpen()"
      mat-icon-button
      matPrefix
      type="button"
    >
      <mat-icon>keyboard</mat-icon>
    </button>
  }

  @if (showClearButton()) {
    <button
      (click)="clear()"
      [title]="'castor.clear_input' | transloco"
      class="mx-1"
      mat-icon-button
      matSuffix
      type="button"
    >
      <mat-icon>close</mat-icon>
    </button>
  }

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)" [displayWith]="displayFn">
    @if (isLoading) {
      <mat-option class="autocomplete-option">
        <div class="flex justify-center p-1">
          <mat-spinner diameter="30"></mat-spinner>
        </div>
      </mat-option>
    }

    @if (!isLoading) {
      @for (option of options; track option) {
        <mat-option (onSelectionChange)="onSelectionChange($event)" [value]="option"
                    class="autocomplete-option">
          <div class="flex justify-between">
            <span [innerHTML]="getLabel(option) | highlight : activeWord"></span>
            @if (showNumOfResults) {
              <span>{{ getNumOfResults(option) }}</span>
            }
          </div>
        </mat-option>
      }
    }
  </mat-autocomplete>
  @if (hint) {
    <mat-hint>{{ hint }}</mat-hint>
  }
</mat-form-field>
